import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import * as Yup from "yup";
import Typography from "@mui/material/Typography";
import { colors } from "../../theme/Colors";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Timer from "../../components/ui/Timer";
import { TextField, Container } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useVerifyPasswordOtp } from "../../hooks/useVerifyPasswordOtp";
import { useForgotPassword } from "../../hooks/useForgotPassword";
import ThreeDIcon from "../../components/ui/ThreeDIcon";
import Button from "@mui/material/Button";
import CarouselSignup from "../../components/ui/CarouselSignup/CarouselSignup";
import logo from "../../imgs/imgV2/flextalent.png";
import FormikErrorText from "../../components/ui/FormikErrorText";
import { ToastContainer } from "react-toastify";

const IconWithText = () => {
  return (
    <>
      <Box display="flex" justifyContent="center" sx={{ marginBottom: "32px" }}>
        <ThreeDIcon name="message" />
      </Box>

      <Box display="flex" flexDirection="column" textAlign="center" sx={{ marginBottom: "32px" }}>
        <Typography variant="text_xl" fontSize="25px" fontWeight="700">
          Réinitialisation de votre mot de passe
        </Typography>
        <Typography variant="text_normal" color={colors.text_subtitle}>
          Un e-mail contenant le code OTP de réinitialisation a été envoyé
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "32px" }}>
        <Typography variant="text_normal">Un e-mail contenant un code de réinitialisation de mot de passe a été envoyé à l'adresse e-mail que vous avez fournie. Veuillez vérifier votre boîte de réception (y compris le dossier spam) pour trouver l'e-mail. </Typography>
      </Box>
    </>
  );
};

function EnterOtpForgotPassword() {
  const [isWaitingForResendLocal, setIsWaitingForResendLocal] = useState(true);

  setTimeout(() => {
    setIsWaitingForResendLocal(false);
  }, 122000);

  //invoke useLocation to pass email to intial values
  const location = useLocation();

  //initialize error, isLoading, and verifyPasswordOtp function
  const { verifyPasswordOtp, errorVerifyPasswordOtp, isLoadingVerifyPasswordOtp, successVerifyPasswordOtp } = useVerifyPasswordOtp();

  //validation for fields
  const validationSchema = Yup.object({
    otp: Yup.string().required("Ce champs est obligatoire"),
  });

  //Form initial values
  const initialValues = {
    email: location.state,
    otp: "",
  };

  //resend initial values
  const initialValuesResend = {
    email: location.state,
  };

  //invoke verifyPasswordOtp that we get from useVerifyPasswordOtp
  const onSubmitEnterOtpForgotPassword = async (values, isLoadingVerifyPasswordOtp, errorVerifyPasswordOtp, successVerifyPasswordOtp) => {
    await verifyPasswordOtp(values.email, values.otp);
  };

  //invoke Resend OTP
  const { forgotPassword, errorForgotPassword, isLoadingForgotPassword, successForgotPassword, isWaitingForResend } = useForgotPassword();

  //onClikc resend OTP
  const onSubmitResend = async (values, isLoadingForgotPassword, errorForgotPassword) => {
    await forgotPassword(values.email);
  };

  return location.state ? (
    <Container maxWidth={"xl"}>
      <ToastContainer />
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        <Box flex={1} display="flex" flexDirection="column" className="left" justifyContent="center" alignItems="center">
          <Box display="flex" width="100%" padding="32px 0px">
            <img width="210px" src={logo} alt="" />
          </Box>

          <Box sx={{ alignItems: "center", background: "white", width: "100%", maxWidth: "416px", padding: "16px 16px 64px 16px", minHeight: "586px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <Box width="100%">
              <IconWithText />

              {/* FORM FOR SENDING THE OTP */}
              <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmitEnterOtpForgotPassword}>
                {({ values, error }) => (
                  <Form>
                    <Box sx={{ display: "flex", flexDirection: "column", marginBottom: "32px" }}>
                      <Box sx={{ marginBottom: "6px" }}>
                        <Typography variant="text_normal" fontWeight="600" htmlFor="otp" name="otp">
                          Code de vérification
                        </Typography>
                      </Box>
                      <Field autoComplete="off" name="otp" type="input" placeholder="code à 6 chiffres" id="otp" as={TextField}></Field>
                      <ErrorMessage name="otp" component={FormikErrorText} />
                    </Box>

                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginBottom: "16px" }}>
                      <Button disabled={isLoadingVerifyPasswordOtp} className="submit" type="submit" variant="mj_primary_md" fullWidth>
                        Vérifier
                      </Button>
                    </Box>

                    {/* {errorVerifyPasswordOtp && (
                      <Alert
                        sx={{
                          border: `1px solid  ${colors.mjRedOutline}`,
                          borderRadius: "12px",
                        }}
                        severity="error"
                      >
                        {errorVerifyPasswordOtp}
                      </Alert>
                    )} */}
                    {/* {successVerifyPasswordOtp && (
                      <Box>
                        <Box display="flex" alignItems="center" justifyContent="center" marginRight="auto"></Box>
                        <Alert
                          sx={{
                            border: `1px solid  ${colors.mjGreenOutline}`,
                            borderRadius: "12px",
                          }}
                          severity="success"
                        >
                          {successVerifyPasswordOtp}
                        </Alert>
                      </Box>
                    )} */}
                  </Form>
                )}
              </Formik>

              {/* RESEND OTP */}
              <Formik initialValues={initialValuesResend} onSubmit={onSubmitResend}>
                {({ values, error }) => (
                  <Form>
                    <Box display="flex" width="100%" sx={{ marginBottom: "1rem", marginTop: "1rem" }}>
                      <Button fullWidth disabled={isWaitingForResend || isLoadingForgotPassword || isWaitingForResendLocal} disableRipple variant="mj_secondary_md" type="submit">
                        Renvoyer le mail
                      </Button>
                      <ErrorMessage name="email" />
                    </Box>

                    {isWaitingForResendLocal && (
                      <Box mb="1rem" display="flex" justifyContent="center">
                        <Timer />
                      </Box>
                    )}
                    {successForgotPassword && (
                      <>
                        <Box mb="1rem" display="flex" justifyContent="center">
                          <Timer />
                        </Box>
                        {/* <Alert
                          sx={{
                            border: `1px solid  ${colors.mjGreenOutline}`,
                            borderRadius: "12px",
                          }}
                          severity="success"
                        >
                          {successForgotPassword}
                        </Alert> */}
                      </>
                    )}
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Box>
        <Box flex={1.1} className="right" sx={{ padding: "32px 32px 32px 0px" }} width="50%" display={{ lg: "flex", xs: "none" }}>
          <CarouselSignup />
        </Box>
      </Box>
    </Container>
  ) : (
    "error 404"
  );
}
const Page = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.main};

  .formContainer {
    border-radius: 24px;
    align-items: center;
    padding: 1.5rem 3rem;
    background: white;
    width: 550px;
    min-height: 600px;
  }

  .field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
  }
  .submit {
    margin-bottom: 1rem;
  }

  label {
    margin-bottom: 0.5rem;
  }

  .timer {
    margin-right: 5px;
  }

  .userEmail {
    color: ${colors.main};
    font-weight: 600;
    margin-bottom: 1rem;
  }
`;

export default EnterOtpForgotPassword;
